export default "__VITE_ASSET__3b8F_mTH__"